@if (ref() || tags()) {
  @if (repost()) {
    <app-ref class="expand"
             [fetchRepost]="false"
             [showToggle]="true"
             [expandInline]="true"
             [ref]="repost()" />
  }
  @if (editingRef()) {
    <app-ref class="list-item expand"
             [fetchRepost]="false"
             [showToggle]="true"
             [expandInline]="true"
             [ref]="editingRef()" />
  }
  @if (playlist()) {
    <app-playlist [ref]="ref()" />
  }
  @if (lens()) {
    @if (lensPage()) {
      <app-lens class="lens-expand"
                [page]="lensPage()"
                [pageControls]="false"
                [tag]="lensQuery()"
                [ext]="ext()"
                [size]="lensSize()"
                [cols]="lensCols()"
                [sort]="lensSort()"
                [filter]="lensFilter()"
                [search]="lensSearch()" />
    } @else {
      <app-loading />
    }
  }
  @if (embedIframe()) {
    <div class="embed-container"
         [class.loading]="!embedReady()"
         [class.twitter]="twitter()"
         [class.zoom]="zoom()"
         [appResizeHandle]="resizable() && !disableResize() && !fullscreen()"
         [child]="iframe">
      <iframe #iframe
              class="embed-expand"
              [class.ready]="embedReady()"
              sandbox="allow-downloads allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-to-custom-protocols"
              src="about:blank"
              frameborder="0"
              scrolling="yes"
              allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
              referrerpolicy="strict-origin-when-cross-origin"></iframe>
    </div>
  }
  @if (imageUrl()) {
    <div #imageEl
         class="image-expand"
         [appImage]="imageUrl()"
         [ref]="ref()"
         [defaultWidth]="ref()?.plugins?.['plugin/image']?.width"
         [defaultHeight]="ref()?.plugins?.['plugin/image']?.height"
         [grid]="disableResize()"
         [appResize]="!disableResize()"
         (appResizeClick)="copyImage(imageEl)"></div>
  }
  @if (videoUrl()) {
    <video #video
           class="video-expand"
           [autoplay]="autoplay()"
           controls
           [appResize]="!disableResize()"
           (playing)="playing.emit(videoUrl())"
           (pause)="!this.ended && pausing.emit(videoUrl())"
           (ended)="ended.emit(videoUrl())">
      <source [src]="videoUrl()">
    </video>
  }
  @if (audioUrl()) {
    <audio #audio
           class="no-resize audio-expand"
           [autoplay]="autoplay()"
           controls
           (playing)="playing.emit(audioUrl())"
           (pause)="!this.ended && pausing.emit(audioUrl())"
           (ended)="ended.emit(audioUrl())">
      <source [src]="audioUrl()">
    </audio>
  }
  @if (qrUrl()) {
    <app-qr class="zoom qr-expand"
            [url]="qrUrl()"
            [appResize]="!disableResize()" />
  }
  @if (mapPage(); as mapPage) {
    @defer {
      <app-map class="map-embed"
               [page]="mapPage"
               [tag]="store.view.tag()"
               [ext]="store.view.viewExt()"
               [pageControls]="false"
               [bbox]="ref()?.plugins?.['plugin/geo']?.bbox"
               [fitFeatures]="true" />
    } @placeholder {
      <app-loading />
    }
  }
  @if (todo()) {
    <app-todo class="zoom"
              [ref]="ref()"
              [text]="text()"
              [tags]="tags()"
              (comment)="comment.emit($event)"
              (copied)="copied.emit($event)" />
  }
  @if (backgammon()) {
    <app-backgammon class="no-resize"
                    [ref]="ref()"
                    [text]="text()"
                    (comment)="comment.emit($event)"
                    (copied)="copied.emit($event)" />
  }
  @if (chess()) {
    <app-chess class="no-resize"
               [white]="chessWhite()"
               [ref]="ref()"
               [text]="text()"
               (comment)="comment.emit($event)"
               (copied)="copied.emit($event)" />
  }
}
@if (code()) {
  <app-md class="code md-container"
          [origin]="currentOrigin()"
          [text]="currentCode()"
          [mermaid]="false"
          [clipboard]="false" />
} @else if (currentText()) {
  <app-md class="zoom md-container"
          [class.expand]="expand()"
          [origin]="currentOrigin()"
          [text]="currentText()"
          [plugins]="currentTags()" />
}
@if (pdf()) {
  <div class="embed-container"
       [appResizeHandle]="!disableResize() && !fullscreen()"
       [child]="pdfIframe"
       [initChild]="true">
    <iframe #pdfIframe
            class="embed-expand ready"
            src="about:blank"
            frameborder="0"
            scrolling="yes"
            allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
            referrerpolicy="strict-origin-when-cross-origin"></iframe>
  </div>
}
@for (ui of uiMarkdowns(); track ui.tag) {
  <app-md class="zoom md-container"
          [class]="uiCss(ui.tag)"
          [disableSanitizer]="true"
          [origin]="currentOrigin()"
          [text]="ui.text" />
}
@if (mod()) {
  <app-mod class="zoom md-container"
           [mod]="mod()"
           [class.expand]="expand()" />
}
